import './style.scss';

const InputBordered = ({ containerClass = '', label, ...rest }) => {
    return <div className={`input-bordered ${containerClass}`}>
        <label htmlFor="input">{label}</label>
        <input id="input" {...rest} />
    </div>;
};

export default InputBordered;